import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
// import { ReactComponent as SortIcon } from "./../../../../assets/svg/sort.svg";
import FilterSidebar from "./FilterSidebar/FilterSidebar";
import SortModal from "./SortModal/SortModal";
import useFilter from "./useFilter";
import useSort from "./useSort";

import { ReactComponent as CancelIcon } from "./../../../../../assets/svg/cancel.svg";
import { ReactComponent as FilterIcon } from "./../../../../../assets/svg/filter.svg";
import Button from "../../../ui/Button";
import { useTranslation } from "react-i18next";

const FilterSort = (props) => {
  const { t } = useTranslation();
  const [filter_open, set_filter_open] = useState(false);

  const [sort_modal, set_sort_modal, sort_list, activeSortLabel] = useSort();
  const [
    filter_list,
    checkbox_change,
    submit_filter,
    current_filters,
    delete_filter,
    clear_filter,
  ] = useFilter();

  const closeDrawerHandler = useCallback(() => {
    set_filter_open(false);
  }, []);

  useEffect(() => {
    if (filter_open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [filter_open]);

  return (
    <div className={"filter-sort-container"}>
      <div className={"filter-container"}>
        <div
          style={{ flexGrow: 1, flexBasis: 0 }}
          className={"filter-container-filter-button mt-2"}
        >
          <Button
            style_justifyContent="flex-start"
            style_width="100%"
            style_border="type-5"
            style_border_active="none"
            style={{
              boxShadow: "0px 0px 6px 1px rgb(0 0 0 / 10%)",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
            style_backgroundColor="white"
            style_color="type-black-2"
            style_color_hover="type-black-2"
            style_color_active="type-black-2"
            style_fontSize="type-3"
            style_paddingLeft={"type-2"}
            style_paddingRight={"type-2"}
            style_borderRadius="type-2"
            onClick={() => set_filter_open(!filter_open)}
            // className={"filter-button"}
          >
            <FilterIcon width={16} height={16} />
            <span>{t("common.filter")}</span>
          </Button>
        </div>
        <div className={"filter-container-sort-button mt-2"}>
          <Button
            style_justifyContent="flex-start"
            style_width="100%"
            style_border="type-5"
            style={{ boxShadow: "0px 0px 6px 1px rgb(0 0 0 / 10%)" }}
            style_backgroundColor="white"
            style_color="type-black-2"
            style_color_hover="type-black-2"
            style_color_active="type-black-2"
            style_fontSize="type-3"
            style_paddingTop="type-0"
            style_paddingBottom="type-0"
            style_paddingLeft="type-2"
            style_paddingRight="type-2"
            style_borderRadius="type-2"
            onClick={() => set_sort_modal(true)}
            className={"sort-button"}
          >
            <div>
              <span className="sort-text">
                {t("common.sort")}
                {activeSortLabel && (
                  <span className="sort-item">
                    ({t(`home.${activeSortLabel}`)})
                  </span>
                )}
              </span>
            </div>
          </Button>
        </div>
      </div>
      <div className={"current-filters-container"}>
        {current_filters.map((filter_item) => {
          //eslint-disable-line
          if (filter_item?.values?.length) {
            return filter_item.values.map((value, index) => {
              return (
                <div
                  key={index}
                  onClick={() =>
                    delete_filter(
                      filter_list.findIndex(
                        (filter_list_item) =>
                          filter_list_item.slug === filter_item.slug
                      ),
                      value
                    )
                  }
                  className={"current-filter-item-container"}
                >
                  <span>
                    {filter_item.slug}: {value}
                  </span>
                  <CancelIcon />
                </div>
              );
            });
          }
        })}
      </div>

      <FilterSidebar
        filter_open={filter_open}
        closeFilterHandler={closeDrawerHandler}
        filter_list={filter_list}
        checkbox_change={checkbox_change}
        submit_filter={() => {
          submit_filter();
          closeDrawerHandler();
        }}
        clear_filter={() => {
          closeDrawerHandler();
          clear_filter();
        }}
      />
      <SortModal
        sort_modal={sort_modal}
        set_sort_modal={set_sort_modal}
        sort_list={sort_list}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    city_id: state.Login.city_id,
  };
};

export default connect(mapStateToProps)(FilterSort);
